import { createReducer } from '@reduxjs/toolkit';

import { ASSETS_TYPES } from '../../constants';
import { AssetsStateType } from '../../types';
import {
  fetchAssets,
  fetchLoans,
  setActiveTabType,
  setAssetsLoading,
  setSearchStatus,
} from '../actions/assets';

const initialState: AssetsStateType = {
  data: {},
  loansData: {},
  loading: {
    info: false,
  },
  status: undefined,
  loansStatus: undefined,
  type: ASSETS_TYPES.SIMPLE,
};

const assetsReducer = createReducer(initialState, (builder) => {
  builder.addCase(setAssetsLoading, (state, action) => {
    state.loading[action.payload.type] = action.payload.value;
  });

  builder.addCase(fetchAssets.fulfilled, (state, action) => {
    state.data.info = action.payload;
  });

  builder.addCase(setActiveTabType, (state, action) => {
    state.type = action.payload.value;
  });

  builder.addCase(setSearchStatus, (state, action) => {
    state.status = action.payload.value;
  });

  builder.addCase(fetchLoans.fulfilled, (state, action) => {
    state.loansData.info = action.payload;
  });
});

export default assetsReducer;
